
// @ts-nocheck
import Vue from 'vue';
import { PropType } from 'vue';
import MenuOrBottomSheet from './MenuOrBottomSheet.vue';

interface FilterOption {
  label: string;
  value: string;
  icon: string;
}

interface FilterOptions {
  featured?: FilterOption;
  dropdown: FilterOption[];
}


export default Vue.extend({
  name: 'DropdownToggle',
  components: {
    MenuOrBottomSheet,
  },
  props: {
    filterOptions: {
      type: Object as PropType<FilterOptions>,
      required: true,
    },
    selectedValue: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      dropdownOpen: false,
      lastSelectedDropdownValue: null as string | null,
      preventMenuOpen: false,
    };
  },
  computed: {
    selectedDropdownOption (): FilterOption | undefined {
      return this.filterOptions.dropdown.find(option => option.value === this.selectedValue);
    },
    selectedDropdownOptionIcon (): string {
      return this.selectedDropdownOption?.icon || this.lastSelectedDropdownOption?.icon || this.filterOptions.dropdown[0]?.icon || '';
    },
    selectedDropdownOptionLabel (): string {
      return this.selectedDropdownOption?.label || this.lastSelectedDropdownOption?.label || this.filterOptions.dropdown[0]?.label || '';
    },
    lastSelectedDropdownOption (): FilterOption | undefined {
      if (!this.lastSelectedDropdownValue) return undefined;
      return this.filterOptions.dropdown.find(option => option.value === this.lastSelectedDropdownValue);
    },
    isDropdownActive (): boolean {
      // Only show grey highlight when both dropdown and featured button exist
      if (!this.filterOptions.featured) {
        return false;
      }
      return this.filterOptions.dropdown.some(option => option.value === this.selectedValue);
    },
  },
  watch: {
    dropdownOpen (newVal: boolean) {
      if (newVal && this.preventMenuOpen) {
        // Prevent the menu from opening
        this.$nextTick(() => {
          this.dropdownOpen = false;
        });
      }
    },
  },
  methods: {
    handleDropdownClick (event: Event) {
      const target = event.target as HTMLElement;
      const isChevronClick = target.closest('.dropdown-arrow') !== null;

      if (isChevronClick) {
        // Just open/close the dropdown without switching
        this.dropdownOpen = !this.dropdownOpen;
      } else {
        // If there's no featured button, just toggle the dropdown normally
        if (!this.filterOptions.featured) {
          this.dropdownOpen = !this.dropdownOpen;
        } else {
          // Just switch to dropdown option without opening (only when featured button exists)
          if (!this.isDropdownActive) {
            this.preventMenuOpen = true;
            const optionToSelect = this.lastSelectedDropdownOption || this.filterOptions.dropdown[0];
            if (optionToSelect) {
              this.selectOption(optionToSelect.value);
            }
            // Reset the flag after a short delay
            this.$nextTick(() => {
              this.preventMenuOpen = false;
            });
          }
        }
      }
    },
    toggleDropdown () {
      // If we're not currently on a dropdown option, switch to the last remembered one
      if (!this.isDropdownActive) {
        const optionToSelect = this.lastSelectedDropdownOption || this.filterOptions.dropdown[0];
        if (optionToSelect) {
          this.selectOption(optionToSelect.value);
        }
      }

      // Toggle the dropdown open/closed
      this.dropdownOpen = !this.dropdownOpen;
    },
    selectOption (value: string, close?: () => void) {
      this.dropdownOpen = false;

      // Remember the last selected dropdown option
      if (this.filterOptions.dropdown.some(option => option.value === value)) {
        this.lastSelectedDropdownValue = value;
      }

      this.$emit('change', value);

      // Close the menu/bottom sheet if close function is provided
      if (close) {
        close();
      }
    },
    handleClickOutside (event: Event) {
      const target = event.target as HTMLElement;
      if (!this.$el?.contains(target)) {
        this.dropdownOpen = false;
      }
    },
    setDefaultDropdownOption () {
      // If no dropdown option is selected and we have dropdown options, select the first one
      // But only if the current selectedValue is not already a valid dropdown option
      const isCurrentValueValidDropdown = this.filterOptions.dropdown.some(option => option.value === this.selectedValue) || this.filterOptions.featured?.value === this.selectedValue;
      if (!isCurrentValueValidDropdown && this.filterOptions.dropdown.length > 0) {
        const firstDropdownOption = this.filterOptions.dropdown[0];
        this.lastSelectedDropdownValue = firstDropdownOption.value;
        this.$emit('change', firstDropdownOption.value);
      }
    },
  },

  mounted () {
    // Close dropdown when clicking outside
    document.addEventListener('click', this.handleClickOutside);

    // Set default dropdown option if none is selected
    this.setDefaultDropdownOption();
  },
  beforeDestroy () {
    document.removeEventListener('click', this.handleClickOutside);
  },
});
